import getPriceMode from "./getPriceMode";
import { GetHeaderLeft, GetHeaderRight } from "@navigations/utils";
import { getHeaderStyleBasedOnProduct } from "@components/common/Header/utils";
import Routes from "@navigations/Routes";
import { ProductCategory } from "@utils/constants";
import { NativeStackNavigationOptions } from "@react-navigation/native-stack";

const getHeaderScreenOptions = ({
  route,
  showHeader = true,
  user,
  activeProduct,
  typography,
  theme,
}: any) => {
  const headerColorBasedOnActiveProductRoutes = [
    Routes.RequestDetailScreen,
    Routes.RequestModifyScreen,
    Routes.FilterScreen,
    Routes.FilterSearchScreen,
    Routes.FindMatchScreen,
    Routes.PDPScreen,
    Routes.SearchResultScreen,
    Routes.FilterSplitScreen,
    Routes.BulkRequestScreen,
    Routes.BulkInitScreen,
    Routes.ReviewPage,
  ];
  const focusedRouteName = route.name;
  const { background, textColor } = getHeaderStyleBasedOnProduct(
    focusedRouteName &&
      headerColorBasedOnActiveProductRoutes.includes(focusedRouteName)
      ? activeProduct
      : ProductCategory.DEFAULT,
    theme
  );

  const priceModeConfig = getPriceMode({
    focusedRouteName,
    background,
    textColor,
    user,
    theme,
  });

  return {
    headerShown: showHeader,
    headerTitleStyle: typography["H2-M"],
    headerTitleAlign: "center",
    headerTitleAllowFontScaling: false,
    headerLeft: () => <GetHeaderLeft textColor={textColor} />,
    headerRight: () => (
      <GetHeaderRight color={textColor} focusedRouteName={focusedRouteName} />
    ),
    ...(!theme.isLargeScreen && priceModeConfig),
  } as NativeStackNavigationOptions;
};

export default getHeaderScreenOptions;
